import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Axios from "axios";

const RangeSelectModal = ({
  show,
  handleClose,
  handleRangeSelect,
  selectedBatchID,
}) => {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [suffix, setSuffix] = useState("");
  const [barcodes, setBarcodes] = useState([]);
  const [barcodeRandomPairs, setBarcodeRandomPairs] = useState([]);
  const [newbatchid, setnewbatchid] = useState("");

useEffect(() => {
  const fetchStoredBatches = async () => {
    try {
      if (!selectedBatchID) return;


      const parts = selectedBatchID.split("-");

      const formattedBatchID = `${parts[0]}-${parts[1]}--${parts[2].padStart(2, "0")}`;

      console.log("FORMATTED BATCH ID:", formattedBatchID);

      const response = await Axios.get(
        `${INVENTORY_API_BASE_URL}/getStoredBatches?orderSeq=${formattedBatchID}`
      );

      console.log(response.data);

      const totalCount = response.data.reduce(
        (sum, item) => sum + item.keyValuePairsCount,
        0
      );

      const nextStart = totalCount + 1;

      setStart(nextStart.toString());
      setEnd((nextStart + 9).toString());

    } catch (error) {
      console.error(error);

      setStart("1");
      setEnd("10");
    }
  };

  fetchStoredBatches();
}, [selectedBatchID]);

  const generateRandomCode = () => {
    const characters =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

    let randomCode = "";

    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(
        Math.random() * characters.length
      );

      randomCode += characters.charAt(randomIndex);
    }

    return randomCode;
  };

  useEffect(() => {
    const pairs = barcodes.map((barcode) => ({
      barcode,
      randomCode: generateRandomCode(),
    }));

    setBarcodeRandomPairs(pairs);
  }, [barcodes]);

 const handleApplyRange = () => {
  const startInt = parseInt(start, 10);
  const endInt = parseInt(end, 10);

  if (
    startInt > endInt ||
    isNaN(startInt) ||
    isNaN(endInt)
  ) {
    alert(
      "Please ensure the start is less than the end and both are valid numbers."
    );

    return;
  }

  handleRangeSelect({
    start: startInt,
    end: endInt,
  });


  const parts = selectedBatchID.split("-");

  const formattedBatchID = `${parts[0]}-${parts[1]}--${parts[2].padStart(2, "0")}`;

  console.log("FORMATTED BATCH ID:", formattedBatchID);

  setnewbatchid(formattedBatchID);


  const generatedBarcodes = [];

  for (let i = startInt; i <= endInt; i++) {
    const barcode = `${formattedBatchID}-${i}`;

    generatedBarcodes.push(barcode);
  }

  setBarcodes(generatedBarcodes);
};

  const postRandomCodesToMongoDB = async () => {
    try {
      const keyValuePairs = barcodeRandomPairs.map(
        (pair) => ({
          key: pair.barcode,
          value: pair.randomCode,
        })
      );

      await Axios.post(
        `${INVENTORY_API_BASE_URL}/storeRandomCode`,
        {
          batchId: newbatchid,
          keyValuePairs,
        }
      );

      alert("Barcodes Stored Successfully");

      window.location.reload();
    } catch (error) {
      console.error(
        "Error storing random codes:",
        error
      );
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      style={{ marginLeft: "20rem" }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Extra Barcode</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "15px",
          }}
        >
<p>{start}</p>
          <input
            type="number"
            placeholder="End"
            value={end}
            onChange={(e) => setEnd(e.target.value)}
          />
        </div>

        <Button onClick={handleApplyRange}>
          Apply Range
        </Button>
      </Modal.Body>

      <Modal.Body>
        <Table bordered>
          <thead>
            <tr>
              <th>Barcode</th>
              <th>Random Code</th>
            </tr>
          </thead>

          <tbody>
            {barcodeRandomPairs.map((pair, index) => (
              <tr key={index}>
                <td>{pair.barcode}</td>

                <td>{pair.randomCode}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
        >
          Close
        </Button>

        <Button
          variant="primary"
          onClick={postRandomCodesToMongoDB}
        >
          Approve
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RangeSelectModal;